// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"3ed9fb2b","433":"8050d865","466":"dfd91164","738":"efacf42a","787":"81acf756","856":"bb94bb5a","858":"4bd5a433","917":"205794e7"}[chunkId] + ".chunk.js";
};